<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "PlainRouterView"
};
</script>

<style scoped>

</style>